import axiosInstance from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import {OrchestratorControllerApi} from './api/api';

export const administrationRootUri = '/admin';

const orchestratorApi = new OrchestratorControllerApi(undefined, 'api' + administrationRootUri, axiosInstance);

const getFeatureFlagByAccountNumber = (featureName: string, defaultActive?: boolean) => {
  return withCancellation(cancelToken =>
    orchestratorApi
      .orchestrateTaskUsingPOST(
        `ALL:${featureName}`,
        undefined,
        defaultActive,
        undefined,
        undefined,
        getAxiosConfig(cancelToken)
      )
      .then(handleResponse)
  );
};

const getLandingPageFooterFeatureFlag = () =>
  withCancellation(cancelToken =>
    orchestratorApi.landingPageFooterUsingGET(getAxiosConfig(cancelToken, undefined, true)).then(handleResponse)
  );

export default {
  getFeatureFlagByAccountNumber,
  getLandingPageFooterFeatureFlag,
};
